import { observable, action } from 'mobx';

export default class TaskStore {
  @observable sessionId = 128;

  @observable status = 'default';

  @action getSessionId() {
    if (this.sessionId >= 255) {
      this.sessionId = 128;
    } else {
      this.sessionId++;
    }
    return this.sessionId;
  }
}

export const taskStore = new TaskStore();
